module.exports = __webpack_public_path__ + "media/images/lb/998-7a447cf6af6df5179daedf489cb8c0c5.svg";